<template>
  <div id="successful-wrap">
    <div class="header">
      <div>
        <p>车家</p>
        <p @click="toHomePage" v-show="!infoType">首页</p>
      </div>
    </div>
    <div class="container">
      <div class="commit_successful_img"><img src="../assets/image/Successful/chejia_commit_successful.png"/></div>

      <div class="progress_container">
        <div class="progress_img"><img src="../assets/image/Successful/chejia_progress.png"/></div>
        <div class="progress_text_container">
            <div class="progress_title">{{!infoType ? '已收到您的咨询，稍后专员将致电给您':'资料提交成功，等待专员电话致电'}}</div>
            <div class="progress_tip">{{!infoType ? '请注意接听021-38开头的固定电话':'电话致电'}}</div>
        </div>
      </div>

      <div class="progress_tip_detail" v-show="infoType">注意为了提高审贷通过率，请注意以下情况</div>
      <div class="progress_tip_detail_content"  v-show="infoType"><p>请务必接听021-38开头的固定电话，并准确回答您的申请信息</p></div>

      <div class="sure_button ":class="{diff_type: !infoType}"><button @click="tapCommit">{{infoType == true ?'完成':'我要获取审批额度'}}</button></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Successful",
    data(){
      return {
        infoType: null
      }
    },
    mounted(){
      window.scrollTo(0, 0)
      if(sessionStorage.getItem("infoType") == null){
        this.$router.push({
          path: '/',
          name: "Homepage",
          params: ''
        })
      }
      if(sessionStorage.getItem("infoType") != 'isSku'){
        this.infoType = true
      }else{
        this.infoType = false
      }
    },
    created(){

    },
    methods: {
      tapCommit() {//点击提交
        const router = this.$router
        if(this.infoType == true){
          router.push({
            path: '/',
            name: "Homepage",
            params: ''
          })
        }else{
          router.push({
            path: '/photo',
            name: "Photo",
            params: ''
          })
        }
      },
      toHomePage(){
        const router = this.$router
        router.push({
          path: '/',
          name: "Homepage",
          params: ''
        })
      },
    }
  }


</script>

<style scoped>
  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;
  }
  #successful-wrap *{
    background-color: #fff;
  }
  #successful-wrap{
    /*border: 1px solid black;*/
    width: 100vw;
  }
  #successful-wrap > .header{
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background-color: #fff;
    color: #222;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
  }
  #successful-wrap > .header > div{
    position: relative;
  }
  #successful-wrap > .header > div > p:first-child {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  #successful-wrap > .header > div > p:last-child {
    position: absolute;
    margin: 0;
    padding: 0;
    /*width: 20%;*/
    height: 0.98rem;
    top: 0;
    left: 0.55rem;
    line-height: 0.98rem;
    font-size: 0.28rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
  }
  #successful-wrap > .container {
    margin-top: 1.14rem;
    width: 100%;
  }
  #successful-wrap > .container > .commit_successful_img {
    margin:0 auto;
    width: 1rem;
    height: 1rem;
  }
  #successful-wrap > .container > .commit_successful_img img {
   width: 100%;
  }
  #successful-wrap > .container > .progress_container {
    margin-top: 1rem;
    width:  100%;
    flex-flow: row;
    display: flex;
  }
  /*#successful-wrap > .container > .progress_container div{*/
  /*  border: 1px solid black;*/
  /*}*/
  #successful-wrap > .container > .progress_container >.progress_img {
    margin-left: 0.55rem;
    width: 0.2rem;
    height: 1.48rem;
    font-size: 0;
    display: flex;
    align-items: center;
  }
  #successful-wrap > .container > .progress_container >.progress_img img {
    width: 100%;
  }
  #successful-wrap > .container > .progress_container >.progress_text_container {
    margin-left: 0.5rem;
    height: 1.48rem;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    font-size: 0.32rem;
  }
  #successful-wrap > .container > .progress_container >.progress_text_container >. progress_title {

  }
  #successful-wrap > .container > .progress_container >.progress_text_container >. progress_tip {
    font-size: 0.28rem;
  }
  #successful-wrap > .container >.progress_tip_detail {
    font-size: 0.24rem;
    margin-top: 0.26rem;
    margin-left: 1.25rem;
    color: #d32023;
  }
  #successful-wrap > .container >.progress_tip_detail_content {
    max-width: 4.93rem;
    margin-top: 0.2rem;
    margin-left: 1.25rem;
  }
  #successful-wrap > .container >.progress_tip_detail_content > p {
    font-size: 0.19rem;
    line-height: 0.4rem;
    letter-spacing: 0.6px;
    color: #666666;
  }

  #successful-wrap > .container > .sure_button {
    padding-bottom: 0.96rem;
    margin-top: 2.68rem;
    width: 100%;
    height: 1rem;
  }
  #successful-wrap > .container > .sure_button button {
    padding: 0;
    margin: 0;
    display: block;
    margin: 0 auto;
    width: 5.83rem;
    height: 1rem;
    font-size: 0.28rem;
    font-weight: normal;
    font-stretch: normal;
    color: #fff;
    border-width: 0;
    outline: none;
    background-image: linear-gradient(-90deg,
    #2694ff 0%,
    #42da94 100%),
    linear-gradient(
      #4080ee,
      #4080ee);
    background-blend-mode: normal,
    normal;
    border-radius: 0.12rem;
  }
  .diff_type {
    margin-top: 4.43rem!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Successful.vue